import styled, { css } from 'styled-components'

import { color, media, radius, spacing, typography } from '../../../themes'
import { SnackbarVariant } from '../types'

/**
 * Snackbar transition duration in ms
 */
export const SNACKBAR_TRANSITION_DURATION = 200

interface ContainerProps {
  variant: SnackbarVariant
  isOpen?: boolean
  isClosing?: boolean
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  background-color: rgba(46, 46, 72, 0.9);
  border-radius: ${radius('sm')};
  padding: ${spacing(4.5)};
  transition: opacity ${SNACKBAR_TRANSITION_DURATION / 1000}s ease-in-out,
    transform opacity ${SNACKBAR_TRANSITION_DURATION / 1000}s ease-in-out;
  opacity: 0;
  transform: scale(0, 0);
  transform-origin: 50% 50%;
  width: 100%;
  color: ${({ variant }) =>
    color(
      variant === 'success'
        ? 'green.01'
        : variant === 'error'
        ? 'red.01'
        : 'white',
    )};

  ${media.tablet} {
    width: auto;
    min-width: 375px;
  }

  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      transform: scale(1, 1);
    `}

  ${({ isClosing }) =>
    isClosing &&
    css`
      opacity: 0;
      transform: scale(0, 0);
    `}

  button, a {
    word-break: keep-all;
  }
`

export const IconContainer = styled.div`
  min-width: 24px;
  min-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Content = styled.div`
  width: 100%;
`

export const Message = styled.div`
  ${typography('subhead3')}
  color: ${color('white')};
  margin-left: ${spacing(2.5)};
`

export const Extra = styled.div`
  ${typography('caption1')}
  color: ${color('white')};
  margin-left: ${spacing(2.5)};
  width: 100%;
`
